module.exports = __webpack_public_path__ + "img/w3_trash_solid_white.f7d76da6.png";